import { put, call, fork, all, select, takeLatest } from "redux-saga/effects";
import * as types from "../constants/actionTypes";
import * as Tools from "../helpers/Tools";
import { log, logAPI } from "../api/andyliticsApi";
import { recompileProfile } from "../api/portalApi";

export default function* membershipsSaga() {
    yield takeLatest([types.MEMBERSHIP_RECOMPILE_START], rebuildProfileData);
}

export function* rebuildProfileData(data) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        var memberData = null;
        var token = data.t || domain.t;
        if (token) {
            memberData = yield Tools.safeCall(recompileProfile, token);
        }
        if (memberData === null || memberData?.result && !memberData.result.isSuccessful || memberData?.result && memberData?.result?.statusCode !== 200) {
            logAPI("MBHWeb.Saga.Membership.RecompileProfile.Failure", start, null, data);
        }
        else {

            let parsedContent = JSON.parse(memberData.result?.responseContent);
            yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: parsedContent });
        }
        logAPI("MBHWeb.Saga.Membership.RecompileProfile", start, null, data);
    }
    catch (ex) {
        if (data && data.callback) {
            data.callback(ex, false);
        }
        logAPI("MBHWeb.Saga.Membership.RecompileProfile.Failure", start, null, data);
        console.error(ex);
    }
}
